import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Link,
    SvgIcon,
} from '@mui/material';
import CheckIcon from '@heroicons/react/24/solid/CheckCircleIcon';
import { useNavigate } from 'react-router-dom';

type SuccessDialogProps = {
    open: boolean;
    onClose: () => void;
};

export const SuccessDialog: FunctionComponent<SuccessDialogProps> = ({
    open,
    onClose,
}) => {
    const navigate = useNavigate();
    const navigateToTickets = () => {
        navigate('/tickets');
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <SvgIcon
                    sx={{
                        mr: 2,
                    }}
                    fontSize='large'
                    color='success'
                >
                    <CheckIcon />
                </SvgIcon>
                Bestellung erfolgreich
            </DialogTitle>
            <DialogContent>
                Die Bestellung wurde erfolgreich abgeschlossen. Der
                Pick-up-Voucher für die Abholung steht im Reiter{' '}
                <Link onClick={navigateToTickets}>Verkäufe - Tickets</Link> in
                der Spalte &quot;PDF&quot; zum Download bereit.
            </DialogContent>

            <DialogActions>
                <Button variant='text' onClick={onClose}>
                    Schließen
                </Button>
            </DialogActions>
        </Dialog>
    );
};
